import { useMe } from '@/features/auth/hooks/useAuth'
import { userHasPermission } from '@/lib/permissions'

/**
 * Who may see the Hierarchy Advisor and who may change its switches - role-based, like every
 * feature (Andrew, 29 Sep 2026). `hierarchy.review` reads findings and asks the advisor;
 * `hierarchy.configure` turns rules off, changes their severity and excludes objects.
 *
 * Read from the /auth/me user (useMe), never the store's login-shaped user, which carries no
 * permissions and would hide the advisor from everyone. The server checks both again.
 */
export function useHierarchyAccess(): { canReview: boolean; canConfigure: boolean } {
    const { data: me } = useMe()
    return {
        canReview: userHasPermission(me, 'hierarchy.review'),
        canConfigure: userHasPermission(me, 'hierarchy.configure'),
    }
}
